import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Quiz } from '../../models/Quiz';
import { EventQuizComponent } from '../../components/Quiz/EventQuizComponent';
import { randomUUID } from '../../components/Quiz/utils';

export const EvenQuizPage = () => {
  const quiz: Quiz = {
    id: '14ed7c4f-50f0-4734-bd33-67144f2e4cf9',
    title: '1º ano Robótica',
    description: 'Quiz de Robótica',
    tags: 'Quiz de Robótica',
    questions: [
      {
        id: '04fb7b67-45d6-4139-97c1-7db9b754e154',
        description: 'Qual parte do computador conecta todas as outras partes?',
        optionA: 'Teclado',
        optionB: 'Monitor',
        optionC: 'CPU',
        optionD: 'Mouse',
        target: 'optionC',
      },
      {
        id: '05d89d6d-4765-408c-8d5f-357546c90136',
        description:
          'Se você usa um looping para fazer o robô pular 5 vezes, quantos pulos ele dará?',
        optionA: '1',
        optionB: '3',
        optionC: '5',
        optionD: '7',
        target: 'optionC',
      },
      {
        id: 'b3409281-f5f1-4fe3-83fe-26bbd573e4e9',
        description: 'O que é um sensor de proximidade em um robô?',
        optionA: 'Um sensor para medir a temperatura ambiente',
        optionB: 'Um sensor para detectar obstáculos ou objetos próximos',
        optionC: 'Um sensor que calcula a velocidade do robô',
        optionD: 'Um sensor que controla a intensidade da luz',
        target: 'optionB',
      },
      {
        id: 'd29f618f-e4d9-493d-9252-d4b510f60244',
        description: 'Qual é a função do software em um robô?',
        optionA: 'Armazenar dados sobre o ambiente',
        optionB: 'Executar os comandos e instruções que guiam o robô',
        optionC: 'Criar as partes físicas do robô',
        optionD: 'Controlar apenas os sensores do robô',
        target: 'optionB',
      },
    ],
    isCompleted: false,
    attempts: 0,
    answers: {},
    note: undefined,
    doneAt: new Date(),
  };
  const [userSessionId, setSessionId] = useState<string>('');

  useEffect(() => {
    let sessionId = localStorage.getItem('quizSessionId');

    if (!sessionId) {
      sessionId = randomUUID();
      localStorage.setItem('quizSessionId', sessionId);
    }

    setSessionId(sessionId);
  }, []);

  return (
    <Wrapper>
      <EventQuizComponent
        userSessionId={userSessionId}
        style={{ width: '100%', height: '100' }}
        quiz={quiz}
      />
    </Wrapper>
  );
};

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  justify-content: center;
  width: 100%;
  height: 100vh;
`;
